import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Homepage from './Pages/Homepage';
import Login from './Pages/Login';
import Orders from './Pages/Orders';
import OrderPage from './Pages/OrderPage';
import Clients from './Pages/Clients';
import ClientPage from './Pages/ClientPage';
import CalendarEvents from './Pages/CalendarEvents';
import AdminPanel from './Pages/AdminPanel';
import PrivateRoute  from './AuthComponents/PrivateRoute';
import LoginRoute  from './AuthComponents/LoginRoute';
import AdminRoute  from './AuthComponents/AdminRoute';
import Sidebar from './Components/Sidebar';
import BannerPage from './Pages/BannerPage';
import AdsPage from './Pages/AdsPage';
import DiscountPage from './Pages/DiscoutPage';
import GuestPage from './Pages/GuestPanel';
import VoucherPage from './Pages/VoucherPage';
import DrinkCategoryPage from './Pages/DrinkCategoryPage';
import DrinkMenuPage from './Pages/DrinkMenuPage';
import HomeBannerPage from './Pages/HomeBannerPage';
import QrLookupPage from './Pages/QrLookupPage';
import QrLookupPopup from './Pages/QrLookupPopup';
import ErrorPage from './Pages/ErrorPage';
import { AuthLoginInfo }  from './AuthComponents/AuthLogin';



function App() {
    const ctx = useContext(AuthLoginInfo);
    console.log(ctx)
    return (
      <BrowserRouter>
        <Sidebar>
          </Sidebar>
            <Routes>
              <Route path='/' exact element={
                  <PrivateRoute>
                    <Homepage />
                  </PrivateRoute>
                } />
              <Route path='/orders' element={
                    <PrivateRoute>
                      <Orders />
                    </PrivateRoute>
                  } />
                <Route path='/orders/:orderId' element={
                    <PrivateRoute>
                      <OrderPage />
                    </PrivateRoute>
                  } />
                <Route path='/clients' element={
                    <PrivateRoute>
                      <Clients />
                    </PrivateRoute>
                  } />
                <Route path='/clients/:clientId' element={
                    <PrivateRoute>
                      <ClientPage />
                    </PrivateRoute>
                  } />
                <Route path='/calendar' element={
                    <PrivateRoute>
                      <CalendarEvents />
                    </PrivateRoute>
                  } />
                <Route path='/banners' element={
                    <PrivateRoute>
                      <BannerPage />
                    </PrivateRoute>
                  } />
                  <Route path='/ads' element={
                    <PrivateRoute>
                      <AdsPage />
                    </PrivateRoute>
                  } />
                  <Route path='/drink-categories' element={
                    <PrivateRoute>
                      <DrinkCategoryPage />
                    </PrivateRoute>
                  } />
                  <Route path='/drink-menu' element={
                    <PrivateRoute>
                      <DrinkMenuPage />
                    </PrivateRoute>
                  } />
                  <Route path='/home-banners' element={
                    <PrivateRoute>
                      <HomeBannerPage />
                    </PrivateRoute>
                  } />
                  <Route path='/guest' element={
                    <PrivateRoute>
                      <GuestPage />
                    </PrivateRoute>
                  } />        
                  <Route path='/voucher' element={
                    <PrivateRoute>
                      <VoucherPage />
                    </PrivateRoute>
                  } />           
                  <Route path='/discounts' element={
                    <PrivateRoute>
                      <DiscountPage />
                    </PrivateRoute>
                  } />                  
                <Route path='/adminPannel' element={
                    <AdminRoute>
                      <AdminPanel />
                    </AdminRoute>
                  } />
              <Route path='/login' element={
                  <LoginRoute>
                    <Login />
                  </LoginRoute>
                } />
              <Route path='/qr-lookup' element={<QrLookupPage />} />
              <Route path='/qr-popup' element={<QrLookupPopup />} />
              <Route path="/error" element={<ErrorPage />} />
              <Route path="*" element={<ErrorPage />} /> 
            </Routes>
      </BrowserRouter>
    );
}

export default App;
